const config = {
	CATEGORY_PRODUCT: 1,
	CATEGORY_MATERIAL: 2,
	CATEGORY_FINISHED: 3,
	CATEGORY_HALF_FINISHED: 4,
	CATEGORY_DISH: 5,
	CATEGORY_TELEGRAM: 6,
	CATEGORY_STORE: 10,

	ORDER_TYPE_ON_TABLE: 1,
	ORDER_TYPE_TAKEAWAY: 2,
	ORDER_TYPE_DELIVERY: 3,
	ORDER_TYPE_ONLINE: 4,
	ORDER_TYPE_SALE: 10,

	REMOVED_GOODS_STATUS_WAITING: 0,
	REMOVED_GOODS_STATUS_COMPLETED: 1,

	REMOVED_GOODS_TYPE_RETURN: 2,
	REMOVED_GOODS_TYPE_REMOVED: 1,

	ORDER_STATUS_NEW: 1,
	ORDER_STATUS_COMPLETED: 20,

	TRANSACTION_CATEGORIES_INCOME: 1,
	TRANSACTION_CATEGORIES_EXPENSE: 2,
	TRANSACTION_TYPE_INCOME: 1,
	TRANSACTION_TYPE_EXPENSE: 2,

	USER_TYPE_SYSTEM: 1,
	USER_TYPE_PROVIDER: 2,
	USER_TYPE_CLIENT: 3,
	USER_TYPE_OTHERS: 4,

	CURRENCY_TYPES: [
		{ title: "сум", label: "UZS", code: "uzs" },
		{ title: "$", label: "USD", code: "usd" },
		{ title: "€", label: "EUR", code: "eur" },
		{ title: "рубль", label: "RUB", code: "rub" },
		{ title: "тенге", label: "KZT", code: "kzt" },
		{ title: "dirxam", label: "AED", code: "aed" },
		{ title: "сомнони", label: "TJS", code: "tjs" }
	],

	USER_ROLE_KITCHENER: "kitchener",
	USER_ROLE_MANAGER: "manager",
	USER_ROLE_OWNER: "owner",
	USER_ROLE_CASHIER: "cashier",
	USER_ROLE_COURIER: "courier",
	USER_ROLE_WAREHOUSE: "warehouse",
	USER_ROLE_PROVIDER: "provider",
	USER_ROLE_EMPLOYEE: "employee",
	USER_ROLE_WAITER: "waiter",
	USER_ROLE_MONO: "mono",
	USER_ROLE_ATTENDANCE: "attendance",

	SMS_SUM: 200,

	API_ROOT: import.meta.env.VITE_API_ROOT,
	SOCKET_URL: import.meta.env.VITE_SOCKET_URL,
	DEFAULT_LANGUAGE: "ru",
	TECH_CARD_ORGANIZATION_ID: import.meta.env.VITE_TECH_CARD_ORGANIZATION_ID || "1202",
	API_LANGUAGES: [
		{ id: 1, code: "uz", title: "Узбекча" },
		{ id: 2, code: "ru", title: "Русский" },
		{ id: 3, code: "en", title: "Английский" }
	]
};

export default config;
